import React from "react";
import { VarIcon } from "@icons/VarIcon";
import { DESCRIPTION, TimelineEvent } from "../Types";
import { TimelineItem as CustomTimelineItem } from "../TimelineItem";

export function VideoAssistantReferee({
    timelineEvent,
    opposite,
    title,
    isOver,
}: {
    isOver: boolean;
    opposite: boolean;
    timelineEvent: TimelineEvent;
    title: string;
}) {
    let headline;

    if (timelineEvent.varDescription === DESCRIPTION.GOAL) {
        headline = isOver ? "Reguläres Tor" : "Mögliches Tor";
    } else if (timelineEvent.varDescription === DESCRIPTION.PENALTY) {
        headline = isOver ? "Elfmeter" : "Möglicher Elfmeter";
    } else if (timelineEvent.varDescription === DESCRIPTION.RED_CARD) {
        headline = isOver ? "Rote Karte" : "Mögliche rote Karte";
    } else if (timelineEvent.varDescription === DESCRIPTION.NO_GOAL) {
        headline = "Kein Tor";
    } else if (timelineEvent.varDescription === DESCRIPTION.NO_PENALTY) {
        headline = "Kein Elfmeter";
    } else if (timelineEvent.varDescription === DESCRIPTION.NO_RED_CARD) {
        headline = "Keine rote Karte";
    }
    return (
        <CustomTimelineItem
            opposite={opposite}
            title={title}
            subline={isOver ? "abgeschlossen" : "VAR Überprüfung"}
            playerData={undefined}
            icon={<VarIcon />}
            headline={headline}
        />
    );
}
